import { Component, Input, OnInit, OnChanges, ChangeDetectorRef, ElementRef, Renderer2, OnDestroy } from '@angular/core';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService, CalculationService } from '../../../services';
import { config, tirePositionOptions, seasonalityOptions, messages } from '../../../constants';
import { ConfirmDismissDialogComponent } from '../../shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { find, debounce, trim, isEqual, toLower, findIndex, split, replace } from 'lodash';
import { VehicleInspectionModalComponent } from 'app/modules/technician/modules/order-overview/components/vehicle-inspection-modal/vehicle-inspection-modal.component';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-new-tire-storage-modal',
  templateUrl: './new-tire-storage-modal.component.html',
  styleUrls: ['./new-tire-storage-modal.component.scss'],
})
export class NewTireStorageModalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() categories: any[] = [];
  @Input() suppliers: any[] = [];
  @Input() rimTypes: any[] = [];
  @Input() locations: any[] = [];
  @Input() qboItemRefs: any[] = [];
  @Input() pricings: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() stock: any = {};
  @Input() tireId: string = '';
  @Input() isLocal: boolean = true;
  @Input() isQboConnected: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() tireType: string = '';
  @Input() serviceItem: any = {};
  @Input() averageCost: number = 0;
  @Input() isAutoLeapItem: boolean = false;
  @Input() defaultTaxable: boolean = false;
  @Input() isTaxable: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() openFrom: string = '';
  @Input() isEnhancedTSEnabled: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() estimateOrderStatus: string = '';
  @Input() isGlobalCategoryEnabled: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isSalesCodeEnabled: boolean = false;
  @Input() canEditClassifications: boolean = false;

  isReadOnly = false;
  tireStorageDisabledTooltip: string = '';
  isPrintingLabel: boolean = false;
  isTireStorageUpdated: boolean = false;
  //isDeepCopy:boolean = true
  defaultSizeObject = {
    size: '',
    code: '',
    cost: '',
    pricingMatrix: null,
    price: '',
    isTaxable: true,
    status: true,
    displayDescOnOrder: true,
    displayHoursOnOrder: true,
  };
  defaultTireInfo: any = {
    tireLabel: '',
    rimType: '',
    treadDepth: '',
    recommendReplacement: false,
    storageLocation: '',
  };
  allDefaultTires: any = [
    {
      tireLabel: tirePositionOptions[0].name,
      rimType: '',
      treadDepth: '',
      recommendReplacement: false,
      storageLocation: '',
      class: 'left',
      focus: {},
      seasonality: new Date().getMonth() + 1,
    },
    {
      tireLabel: tirePositionOptions[1].name,
      rimType: '',
      treadDepth: '',
      recommendReplacement: false,
      storageLocation: '',
      class: 'right',
      focus: {},
    },
    {
      tireLabel: tirePositionOptions[2].name,
      rimType: '',
      treadDepth: '',
      recommendReplacement: false,
      storageLocation: '',
      class: 'bottom-left',
      focus: {},
    },
    {
      tireLabel: tirePositionOptions[3].name,
      rimType: '',
      treadDepth: '',
      recommendReplacement: false,
      storageLocation: '',
      class: 'bottom-right',
      focus: {},
    },
  ];
  tirePositionOptions: any[] = tirePositionOptions;
  tire: any = {
    brand: null,
    model: '',
    vendor: null,
    seasonality: 'summer',
    stocked: '',
    sizes: [this.defaultSizeObject],
    tiresInfo: this.allDefaultTires,
    errors: [],
  };
  defaultTireData: any = {
    brand: null,
    model: '',
    vendor: null,
    seasonality: '',
    stocked: '',
    sizes: [this.defaultSizeObject],
    tiresInfo: [],
    errors: [],
  };
  defaultActiveState: boolean = true;
  tagsSuggestion: any[] = [];
  vendorsSuggestion: any[] = [];
  isProcessing: boolean = false;
  errors: any = {};
  defaultQboItemRefs: any[] = [];
  focus: any = {};
  disabledDuplicate: boolean = false;
  seasonalityOption: any[] = seasonalityOptions;
  isNewCategoriesEnabled: boolean = false;
  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  subCategoriesSuggestionsResults: any[] = [];
  subSubCategoriesSuggestionsResults: any[] = [];
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  defaultSalesCode: any = {};
  isAutoAssign: boolean = false;
  defaultTireCategory: any = null;
  isAllTiresSame: boolean = true;
  tableConfig = {
    offset: 0,
    limit: config.pageSize,
    sortField: 'title',
    sortOrder: 1,
    search: '',
  };
  locationResults: any = [];
  vehicleRecommendedSizes: any = [];
  allVehicleSizes: any = [];
  binResults: any = [];
  bins: any = [];
  tireSize: any = {};
  loadingSizes: boolean = false;
  loadingModels: boolean = false;
  isOpenSizeDp: boolean = true;
  vehicleSizeSectionName = 'Width';
  isCreateNew: boolean = false;
  isEditModeCode: boolean = false;
  newWarehouse: any = {
    name: '',
    capacity: '',
  };
  newBin: any = {
    name: '',
  };
  isTireConnectConnected: boolean = false;
  tireConnectBrands: any = [];
  tireConnectModels: any = [];
  isOpenFromInventory: boolean = false;
  allBrands: any = []
  service: any = {};
  companyLocalization: any;
  currentLang: string = 'en';
  lastTireStorage: any = {};
  byPassPopulateOtherTires: boolean = false;
  usePastStorageTooltip: string = '';
  usePastStorageBtnText: string = '';
  isUsedPastStorageAllSame: boolean = true;
  dataSubscription: Subscription;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private calculationService: CalculationService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.isLoading = true;
    if(this.serviceItem?.tireStorageStatus === 'return') this.isReadOnly = true;

    if(this.data?.serviceData) {
      this.service = this.helperService.deepCopy(this.data.serviceData);
      this.companyLocalization = this.data.companyLocalization;
      this.isFinalizedRo = this.data.isFinalizedRo;
      this.currentLang = this.data.currentLang;
    }
    this.getVehicleData();
    this.getVehicleTireSizes({});
    this.searchLocation();
    this.checkForTireConnectConnection();
    this.setDataListener();

    this.tire.tiresInfo.forEach((element) => {
      const currentMonth = new Date().getMonth() + 1;
      if ([10, 11, 12, 1, 2].includes(currentMonth)) element.seasonality = 'summer';
      else element.seasonality = 'winter';
    });
    if (this.openFrom === 'RO') {
      this.isLockedRO = this.dataService.isLockedRO;
    }

    if(this.data && this.data?.vehicle && this.data.vehicle?.vehicleId) {
      this.getLastTireStorageData(this.data.vehicle.vehicleId);
    }
  }

  ngOnDestroy(): void {
    if(this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

  setDataListener() {
    this.dataSubscription = this.dataService.getData().subscribe((payload) => {
      if (payload.data && payload.data.key === 'open-inspection-modal-data-update') {
        this.service = this.helperService.deepCopy(payload.data?.data);
      }
    });

  }

  isInspectionCompleted(): boolean {
    let isComplete = true;
    if(this.service.inspection && this.service.inspection?.inspectionId && this.item.associatedInspection && this.service.inspection?.inspectionId?.isTireStorageInspection) {
      for (const ins of this.service.inspection?.inspectionId?.category) {
        isComplete = ins?.inspectionItems?.every(item => item.colorIndex !== null && item.colorIndex >= 0)
        if (!isComplete) {
          break;
        }
      }
    }
    return isComplete;
  }

  getEstimateInspection(inspectionId: string, estimateId: string) {
    if(inspectionId) {
      this.httpService.getEstimateInspectionDetails(inspectionId, estimateId, true, true).then(
        (res: any) => {
          this.service.inspection = {
            inspectionId: res
          };
          if(res?.category && res?.category?.length) {
            const { inspectionItems } = res?.category[0];
            if(inspectionItems) {
              this.setTiresInfoInspectionData(inspectionItems);
            }
          }
        }, (err: any) => {
          this.helperService.showToaster('error', err);
        }
      );
    }

  }

  setTiresInfoInspectionData(inspectionItems: any[]) {
    if(inspectionItems?.length && this.tire?.tiresInfo && this.tire.tiresInfo?.length) {
      this.tire.tiresInfo?.forEach((tireInfo: any) => {
        const insItem = find(inspectionItems, {tireId: tireInfo?._id});
        if(insItem && insItem?.conditions?.length) {
          const treadDepths = insItem?.conditions?.filter((condition: any) => {
            return condition?.isSelected && condition?.name?.indexOf('/ 32') > -1
          });
          if(treadDepths?.length) {
            const replacedValue = replace(replace(treadDepths[0].name,'\"', ''), / /g, '');
            const treadDepth = split(replacedValue, '/')[0];
            tireInfo.treadDepth = treadDepth;
          }
          tireInfo.recommendReplacement = (insItem?.colorIndex !== 0 && insItem?.colorIndex !== -1);
        }
      });
    }
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;
    this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        this.setCategories(this.categories);
        this.setSuppliers(this.suppliers);
        this.setItemDetails(this.item);
        if(this.openFrom === 'tire-storage-list' && this.item.associatedInspection) {
          if(this.item?.tireStorageStatus === 'return') {
            this.isReadOnly = true;
          }
          this.getEstimateInspection(this.item.orderInspectionId, this.item.storageRO?.orderId);
        }

        if (!this.tireId && this.tire.sizes && this.tire.sizes[0]) {
          this.tire.sizes[0].isTaxable = this.isTaxable;
        }
      }
    }
  }

  initializePricings() {
    if (!this.tireId) {
      this.setTireData();
    }
  }

  setCategories(categories: any[]) {
    this.tagsSuggestion = [...categories];
    this.allBrands = [...categories]
    this.cdr.detectChanges();
  }

  setSuppliers(suppliers: any[]) {
    this.vendorsSuggestion = [...suppliers];
  }

  setItemDetails(tire: any) {
    if (!this.tireId || !tire) {
      // this.tire.sizes[0].commissionable = this.dataService.isCommissionTireStorage;
      // if (this.isEnhancedTSEnabled) {
      //   this.handleAddTireInfo(this.defaultTireInfo);
      // }
      // return;
    }

    this.tire = {
      errors: [],
      model: tire.model ? tire.model : tire?.tiresInfo?.length ? tire?.tiresInfo[0]?.model : '',
      seasonality: tire.seasonality || tire?.tiresInfo?.length && tire?.tiresInfo[0]?.seasonality || 'summer',
      stocked: tire.stocked,
      externalId: tire.externalId,
      salesCode: tire.salesCode,
      isInStorage: tire.isInStorage,
      isReturned: tire.isReturned,
      category: tire.category,
      tiresInfo: this.tire.tiresInfo,
      sizes: [
        {
          isTaxable: tire.isTaxable,
          status: tire.status,
          size: tire.size,
          stocked: tire.stocked,
          count: Number(tire.count),
          title: tire.title,
          tireID: this.tireId,
          code: tire.code,
          restockLevel: tire.restockLevel || null,
          cost: Number(tire.cost),
          price: Number(tire.price),
          description: tire.description || null,
          descriptionFR: tire.descriptionFR || null,
          notes: tire.notes || null,
          totalCost: Number(tire.cost) * Number(tire.count),
          totalPrice: Number(tire.price) * Number(tire.count),
          displayDescOnOrder: tire.displayDescOnOrder,
          displayHoursOnOrder: tire.displayHoursOnOrder,
          internalNotes: tire.notes || null,
        },
      ],
      internalNotes: tire.notes,
    };

    // if (this.isNewCategoriesEnabled) {
    //   if (!this.tire.category?._id && this.defaultTireCategory?._id) {
    //     this.tire.category = this.defaultTireCategory;

    //     if (this.defaultTireCategory.salesCode?.salesCodeId) {
    //       this.tire.salesCode = this.defaultTireCategory.salesCode;
    //     }
    //   }
    // }

    if (this.isEnhancedTSEnabled) {
      this.tire.title = tire.title;
    }

    if (tire.qboId) {
      this.tire.qboId = tire.qboId;
    }

    if (tire.isInStorage) {
      this.tireStorageDisabledTooltip = `Already ${tire.isReturned ? 'returned' : 'stored'} tires can not be edited`;
    }

    // if (tire.category && tire.category.categoryId) {
    //   this.tire.brand = {
    //     _id: tire.category.categoryId,
    //     name: tire.category.name,
    //   };
    // } else {
    //   this.tire.brand = {
    //     name: tire.brand,
    //   };
    // }

    if (tire.supplier && tire.supplier.name) {
      this.tire.vendor = {
        _id: tire.supplier.supplierId,
        name: tire.supplier.name,
      };
    }

    if (tire.pricing && tire.pricing.pricingId) {
      this.tire.sizes[0].pricingMatrix = {
        _id: tire.pricing.pricingId._id,
        name: tire.pricing.pricingId.name,
      };
    }

    if (this.isSalesCodeEnabled) {
      this.defaultSalesCode = this.helperService.deepCopy(tire?.salesCode);
    }

    this.setSelectPricing();
    this.setItemRef();
    this.setTireData();
    this.isProcessing = false;
    this.defaultTireData = this.helperService.deepCopy(this.tire);
  }

  selectTirePosition(position, tireInfo) {
    tireInfo.tireLabel = position.name;
    tireInfo.class = position.class;
    this.dataService.sendClickEvent({ isHideOverlay: true });
  }

  displaySalesCodeTitle() {
    return this.helperService.displaySalesCodeTitle(this.tire.salesCode, this.tire.category);
  }

  openAssignSalesCodeDialog() {
    if (!this.canEditClassifications && this.openFrom !== 'RO') {
      return;
    }
    const data = {
      item: this.tire,
      openFrom: 'tireStorage-modal',
    };
    data.item.title = data.item?.title || '';
    this.dataService.sendData(this.dataService.typeDialog('open-sales-code-assign-modal', 'tireStorage-modal', null, null, data));
  }

  makeTireDataBackwardCompatible(element: any) {
    if(toLower(element.tireLabel) === toLower('LF') || toLower(element.tireLabel) === toLower('Front left')) {
      element.tireLabel = 'Front left (FL)'
    }
    if(toLower(element.tireLabel) === toLower('RF') || toLower(element.tireLabel) === toLower('Front right')) {
      element.tireLabel = 'Front right (FR)'
    }
    if(toLower(element.tireLabel) === toLower('LR') || toLower(element.tireLabel) === toLower('Rear left')) {
      element.tireLabel = 'Rear left (RL)'
    }
    if(toLower(element.tireLabel) === toLower('RR') || toLower(element.tireLabel) === toLower('Rear right')) {
      element.tireLabel = 'Rear right (RR)'
    }
    if(toLower(element.tireLabel) === toLower('1S') || toLower(element.tireLabel) === toLower('1 Spare')) {
      element.tireLabel = 'Spare 1'
    }
    if(toLower(element.tireLabel) === toLower('2S') || toLower(element.tireLabel) === toLower('2 Spare')) {
      element.tireLabel = 'Spare 2'
    }
  }

  setTireData(isMappingNeeded: boolean = false) {
    if (this.serviceItem && this.serviceItem.itemId) {
      // if (this.serviceItem.model) {
      //   this.tire.model = this.isTireConnectConnected && this.serviceItem.model?.name ? this.serviceItem.model.name : this.serviceItem.model;
      // }

      if (this.serviceItem.rimType) {
        this.tire.rimType = this.serviceItem.rimType;
      }

      const size = {
        ...this.tire.sizes[0],
        description: this.serviceItem.description,
        notes: this.serviceItem.notes,
        descriptionFR: this.serviceItem.descriptionFR,
      };

      if (this.item.tiresInfo && this.item.tiresInfo.length) {
        let updTiresInfo = JSON.parse(JSON.stringify(this.item.tiresInfo));
        updTiresInfo.forEach(element =>{
          delete element.tireLabel;
          delete element._id;
          delete element.storageLocation;
          delete element.storageBin;
          delete element.treadDepth;
          delete element.tirePosition;
          delete element.recommendReplacement;
          delete element.treadDepth;
        });
        if(!this.arraysAllObjectsEqual(updTiresInfo)) {
          this.isAllTiresSame = false;
        }
        this.tire.tiresInfo = this.item.tiresInfo;
        if (this.item.tiresInfo[0].storageLocation) {
          this.tire.storageLocation = find(this.locations, { locationId: this.item.tiresInfo[0].storageLocation && this.item.tiresInfo[0].storageLocation.locationId });
          this.searchBin('', true);
        }

        this.tire.tiresInfo.forEach((element, index) => {
          if (element.tireLabel) {
            if(toLower(element.tireLabel) === toLower('LF')) {
              element.tireLabel = 'Front left (FL)'
            }
            if(toLower(element.tireLabel) === toLower('RF')) {
              element.tireLabel = 'Front right (FR)'
            }
            if(toLower(element.tireLabel) === toLower('LR')) {
              element.tireLabel = 'Rear left (RL)'
            }
            if(toLower(element.tireLabel) === toLower('RR')) {
              element.tireLabel = 'Rear right (RR)'
            }
            if(toLower(element.tireLabel) === toLower('1S')) {
              element.tireLabel = 'Spare 1'
            }
            if(toLower(element.tireLabel) === toLower('2S')) {
              element.tireLabel = 'Spare 2'
            }
            this.makeTireDataBackwardCompatible(element);
            const position = find(this.tirePositionOptions, { name: element.tireLabel });
            const positionValue = find(this.tirePositionOptions, { value: element.tireLabel });
            if(position) {
              element.class = position.class;
            } else if(positionValue) {
              element.class = positionValue.class;
            }

          }
          if (element.rimType) {
            element.rimType = find(this.rimTypes, { name: element.rimType });
            this.tire.rimType = { ...element.rimType };
          }
          if (element.size) {
            const tSize = this.helperService.tireSizeParser(element.size);//element.size.split('/');
            element.width = tSize?.tireWidth || '';
            element.ratio = tSize?.tireProfile || '';
            element.rim = tSize?.tireSize || '';
            this.tireSize.width = tSize?.tireWidth || '';
            this.tireSize.ratio = tSize?.tireProfile || '';
            this.tireSize.rim = tSize?.tireSize || '';
          } else if(size.size) {
            const tSize = this.helperService.tireSizeParser(size.size);//element.size.split('/');
            element.width = tSize?.tireWidth || '';
            element.ratio = tSize?.tireProfile || '';
            element.rim = tSize?.tireSize || '';
            this.tireSize.width = tSize?.tireWidth || '';
            this.tireSize.ratio = tSize?.tireProfile || '';
            this.tireSize.rim = tSize?.tireSize || '';
          }

          if(!element.brand) {
            if (this.serviceItem.category && this.serviceItem.category.categoryId) {
              element.brand = {
                _id: this.serviceItem.category.categoryId,
                name: this.serviceItem.category.name,
              };
            } else if(this.serviceItem.brand) {
              element.brand = {
                name: this.serviceItem.brand,
              };
            }
          }
          if(!element.model) {
            element.model = this.serviceItem.model;
          }
          setTimeout(() => {
            if (element.model && this.isTireConnectConnected) {
              // element.model = { name: element.model };
              this.tire.model = element.model;
            }
            if (this.isTireConnectConnected && element.width && element.ratio && element.rim){
              const data = {...element};
              delete data.brand;
              this.getTireConnectBrands(data, true, null, false, element);
            }else if (!this.isTireConnectConnected && element.width && element.ratio && element.rim){
              element.tagsSuggestion = [...this.categories];
              element.allBrands = [...this.categories];
            }
          }, 1000);
        });

        if(this.isAllTiresSame) this.onSelectTire(false);
      }

      if (this.item.tiresInfo && this.item.tiresInfo.length === 0) {
        this.tire.tiresInfo = this.allDefaultTires;
        this.item.tiresInfo = this.allDefaultTires;
      }

      if (this.serviceItem.count > this.item.tiresInfo?.length && this.item.tiresInfo?.length) {
        const diff = this.serviceItem.count - this.item.tiresInfo.length;
        for (var i = 0; i <= diff - 1; i++) {
          const lastTire = this.helperService.deepCopy(this.item.tiresInfo[this.item.tiresInfo.length - 1]);
          const index = findIndex(this.tirePositionOptions, { name: lastTire.tireLabel });
          if (index !== -1 && index < 5) {
            const updTire = { ...this.tirePositionOptions[index + 1] };
            const prevTire = {
              model: lastTire.model,
              size: '',
              seasonality: lastTire.seasonality,
              storageBin: lastTire.storageBin || null,
              tireLabel: updTire.name,
              rimType: find(this.rimTypes, { name: lastTire.rimType }),
              storageLocation: find(this.locations, { locationId: lastTire?.storageLocation && lastTire?.storageLocation.locationId }),
              brand: { _id: lastTire?.brand?.brandId, name: lastTire?.brand?.name },
              class: updTire.class,
              focus: {},
            };
            this.tire.tiresInfo.push(prevTire);
          } else {
            const prevTire = {
              model: lastTire.model,
              size: '',
              seasonality: lastTire.seasonality,
              storageBin: lastTire.storageBin || null,
              tireLabel: '',
              rimType: find(this.rimTypes, { name: lastTire.rimType }),
              storageLocation: find(this.locations, { locationId: lastTire?.storageLocation && lastTire?.storageLocation.locationId }),
              brand: { _id: lastTire?.brand?.brandId, name: lastTire?.brand?.name },
              class: '',
              focus: '',
            };
            this.tire.tiresInfo.push(prevTire);
          }
        }
      } else if (this.serviceItem.count < this.item.tiresInfo?.length) {
        const diff = this.item.tiresInfo.length - this.serviceItem.count;
        this.tire.tiresInfo = this.tire.tiresInfo.slice(0, -diff);
      }

      this.checkTiresStatus();

      // if (this.serviceItem.description) {
      //   this.tire.internalNotes = this.serviceItem.description;
      // }

      if (this.serviceItem.hasOwnProperty('seasonality')) {
        this.tire.seasonality = this.serviceItem.seasonality || (this.tire.tiresInfo?.length ? this.tire.tiresInfo[0].seasonality : '');
      }

      if (this.serviceItem.title) {
        this.tire.title = this.serviceItem.title;
      }

      if (this.serviceItem.titleFR) {
        this.tire.title = this.serviceItem.titleFR;
      }

      if (this.serviceItem.hasOwnProperty('salesCode') && this.serviceItem.salesCode?.salesCodeId) {
        this.tire.salesCode = this.serviceItem.salesCode;
      }

      // if (this.serviceItem.category && this.serviceItem.category.name) {
      //   const { categoryId, name } = this.serviceItem.category;
      //   this.tire.brand = { name };

      //   if (categoryId) this.tire.brand._id = categoryId;
      // }

      if (this.serviceItem.supplier && this.serviceItem.supplier.name) {
        const { supplierId, name } = this.serviceItem.supplier;
        this.tire.vendor = { name };

        if (supplierId) this.tire.vendor._id = supplierId;
      }

      if (this.serviceItem.hasOwnProperty('price')) {
        size.price = this.serviceItem.price;
      }

      if (this.serviceItem.hasOwnProperty('cost')) {
        size.cost = this.serviceItem.cost;
      }

      if (this.serviceItem.hasOwnProperty('isTaxable')) {
        size.isTaxable = this.serviceItem.isTaxable;
      }

      if (this.serviceItem.hasOwnProperty('commissionable')) {
        size.commissionable = this.serviceItem.commissionable;
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        size.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        size.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.code) {
        size.code = this.serviceItem.code;
      }

      if (this.serviceItem.size) {
        size.size = this.serviceItem.size;
      }

      if (this.serviceItem.hasOwnProperty('count')) {
        size.count = this.serviceItem.count;
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        size.pricingMatrix = this.serviceItem.pricing;
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        size.pricingMatrix = {
          _id: this.serviceItem.pricing.pricingId,
          name: this.serviceItem.pricing.name,
        };
      }

      if (!isNaN(size.price) && !isNaN(size.cost) && !isNaN(size.count)) {
        size.totalPrice = this.calculationService.roundOff(Number(size.price * size.count));
        size.totalCost = this.calculationService.roundOff(Number(size.cost * size.count));
      }

      this.tire.sizes = [size];

      if (this.serviceItem.qboId) {
        this.tire.qboId = this.serviceItem.qboId;
        this.setItemRef();
      }

      if (isMappingNeeded) {
        this.setSelectPricing();
      }
    } else {
      if (this.item.tiresInfo && this.item.tiresInfo.length) {
        // let updTiresInfo = JSON.parse(JSON.stringify(this.item.tiresInfo));
        // updTiresInfo.forEach(element =>{
        //   delete element.tireLabel;
        //   delete element._id;
        //   delete element.storageLocation;
        //   delete element.storageBin;
        //   delete element.treadDepth;
        //   delete element.tirePosition;
        // });
        // if(!this.arraysAllObjectsEqual(updTiresInfo)) {
        //   this.isAllTiresSame = false;
        // }
        this.isAllTiresSame = false;
        this.tire.tiresInfo = this.item.tiresInfo;
        if (this.item.tiresInfo[0].storageLocation) {
          this.tire.storageLocation = find(this.locations, { locationId: this.item.tiresInfo[0].storageLocation && this.item.tiresInfo[0].storageLocation.locationId });
          this.searchBin('', true);
        }

        this.tire.tiresInfo.forEach((element) => {
          if (element.tireLabel) {
            this.makeTireDataBackwardCompatible(element);
            const position = find(this.tirePositionOptions, { name: element.tireLabel });
            const positionValue = find(this.tirePositionOptions, { value: element.tireLabel });
            if(position) {
              element.class = position.class;
            } else if(positionValue) {
              element.class = positionValue.class;
            }
          }
          if (element.rimType) {
            element.rimType = find(this.rimTypes, { name: element.rimType });
            this.tire.rimType = { ...element.rimType };
          }
          if (element.size) {
            const tSize = this.helperService.tireSizeParser(element.size);//element.size.split('/');
            element.width = tSize?.tireWidth || '';
            element.ratio = tSize?.tireProfile || '';
            element.rim = tSize?.tireSize || '';
            this.tireSize.width = tSize?.tireWidth || '';
            this.tireSize.ratio = tSize?.tireProfile || '';
            this.tireSize.rim = tSize?.tireSize || '';
          } else if (this.tire.sizes?.length){
            const size = {
              ...this.tire.sizes[0]
            };
            const tSize = this.helperService.tireSizeParser(size.size);//element.size.split('/');
            element.width = tSize?.tireWidth || '';
            element.ratio = tSize?.tireProfile || '';
            element.rim = tSize?.tireSize || '';
            this.tireSize.width = tSize?.tireWidth || '';
            this.tireSize.ratio = tSize?.tireProfile || '';
            this.tireSize.rim = tSize?.tireSize || '';
          }
          if (element.model && this.isTireConnectConnected) {
            //element.model = { name: element.model };
            this.tire.model = element.model;
          }else if (!element.model && this.tire.model) {
            //element.model = { name: element.model };
            element.model = this.tire.model;
          }
          // if (element.brand && this.isTireConnectConnected){
          //   element.brand._id = element.brand.brandId;
          //   this.getTireConnectBrands(element, false, element);
          // }
          if(!element.brand) {
            if (this.item.category && this.item.category.categoryId) {
              element.brand = {
                _id: this.item.category.categoryId,
                name: this.item.category.name,
              };
            } else if(this.item.brand) {
              element.brand = {
                name: this.item.brand,
              };
            }
          }

        });

        if(this.openFrom === 'tire-storage-list') {
          let updTiresInfo = JSON.parse(JSON.stringify(this.item.tiresInfo));
          updTiresInfo.forEach(element =>{
            delete element.tireLabel;
            delete element._id;
            delete element.storageLocation;
            delete element.storageBin;
            delete element.treadDepth;
            delete element.tirePosition;
            delete element?.class;
            delete element?.treadDepth;
            delete element?.recommendReplacement;
          });
          if(!this.arraysAllObjectsEqual(updTiresInfo)) {
            this.isAllTiresSame = false;
          } else {
            this.isAllTiresSame = true;
            this.tire.brand = this.item.tiresInfo[0]?.brand;
          }
        }



        // if(this.isAllTiresSame) this.onSelectTire(false);
      }

      this.isOpenFromInventory = true;

      if (this.item.tiresInfo && this.item.tiresInfo.length === 0) {
        this.tire.tiresInfo = this.allDefaultTires;
        this.item.tiresInfo = this.allDefaultTires;
      }



      this.checkTiresStatus()
    }
  }

  arraysAllObjectsEqual(arr) {
    if (!Array.isArray(arr) || arr.length <= 1) {
      return true;
    }

    const firstElement = JSON.stringify(arr[0]);

    for (let i = 1; i < arr.length; i++) {
      // if (!isEqual(arr[0], arr[i])) return false;
      if (JSON.stringify(arr[i]) !== firstElement) {
        console.log(arr[i]);

        return false;
      }
    }

    return true;
  }

  checkTiresStatus() {
    this.tire.tiresInfo.forEach((tire) => {
      if (tire.width?.toString() && tire.ratio?.toString() && tire.rim?.toString() && tire.model && (tire.brand?.brandId || tire.brand?._id) && tire.rimType) {
        tire.isCompleted = true;
      } else {
        tire.isCompleted = false;
      }
    });
  }

  /** Fetching items reference from QBO */
  fetchItemRefs() {
    this.httpService.getQBOItemRefs().then(
      (data: any) => {
        if (data.items && data.items.length) {
          this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
          this.setItemRef();
          this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  setSelectPricing() {
    if (this.tire.sizes && this.tire.sizes[0].pricingMatrix && this.pricings && this.pricings.length) {
      const [pricing] = this.pricings.filter(({ _id }) => _id === this.tire.sizes[0].pricingMatrix._id);

      if (pricing) {
        this.tire.sizes[0].pricingMatrix = pricing;
      }
    }
  }

  getCompanyDetails() {
    return new Promise((resolve, reject) => {
      const { companyId } = this.helperService.getCompany();

      this.httpService.getCompanyDetails(companyId).then(
        (company) => {
          if (company && company.shop) {
            // this.isTaxable = company.shop.tire;
            // this.defaultSizeObject.isTaxable = this.isTaxable;
          }

          resolve({});
        },
        (err) => {
          reject(err);
          this.helperService.showToaster('error', err);
        },
      );
    });
  }

  getTireConnectBrands(tire, getBrands = true, tireSize = null, fromTireConnect=false, tireInfo?: any) {
    if(!this.isTireConnectConnected) return;
    this.loadingModels = true;
    if(tire.brand && (tire.brand.brandId || tire.brand?._id) && !fromTireConnect){
      const brandId = tire.brand.brandId || tire.brand?._id;
      let index;
      if(tireInfo) index = findIndex(tireInfo?.tireConnectBrands, { _id: brandId });
      else index = findIndex(this.tireConnectBrands, { _id: brandId });
      if(index === -1) return;
    }
    const options: any = {
      tireSize: tireSize?.rim || tire.rim,
      brands: getBrands ? '' : tire.brand?.brandId || tire.brand?._id || '',
      tireWidth: tireSize?.width || tire.width,
      tireProfile: tireSize?.ratio || tire.ratio,
      isFiltersNeeded: true,
    };
    this.httpService
      .getTireConnectInventory(options)
      .then(
        (data: any) => {
          this.loadingModels = false;
          const { currentTime, tires, brands } = data;
          if(tireInfo){
            if (getBrands) {
              tireInfo.tireConnectBrands = brands.map(({ _id, name }) => ({ _id, name, isTireConnect: true }));
              const mergedArray = [...tireInfo.tireConnectBrands, ...this.categories];
              const uniqueObjects = mergedArray.filter((obj, index) => {
                return mergedArray.findIndex(item => item.name === obj.name) === index;
              });
              tireInfo.allBrands = [...uniqueObjects];
              tireInfo.tagsSuggestion = [...tireInfo.tireConnectBrands, ...this.categories];
            }else {
              tire.model = '';
              this.checkTiresStatus();
              //removing duplicate by grouping it together
              let modelsData: any = {};
              tires?.forEach(({ model }) => {
                modelsData[model] = { name: model };
              });
              if(Object.keys(modelsData || {})?.length) {
                tireInfo.tireConnectModels = Object.values(modelsData);
              } else {
                tireInfo.tireConnectModels = [];
              }
            }
          }else{
            if (getBrands) {
              this.tireConnectBrands = brands.map(({ _id, name }) => ({ _id, name, isTireConnect: true }));
              const mergedArray = [...this.tireConnectBrands, ...this.categories];
              const uniqueObjects = mergedArray.filter((obj, index) => {
                return mergedArray.findIndex(item => item.name === obj.name) === index;
              });
              this.allBrands = [...uniqueObjects];
              this.tagsSuggestion = [...this.tireConnectBrands, ...this.categories];
            }else {
              tire.model = '';
              this.checkTiresStatus();
              //removing duplicate by grouping it together
              let modelsData: any = {};
              tires?.forEach(({ model }) => {
                modelsData[model] = { name: model };
              });
              if(Object.keys(modelsData || {})?.length) {
                this.tireConnectModels = Object.values(modelsData);
              } else {
                this.tireConnectModels = [];
              }
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.loadingModels = false;
      });
  }

  getVehicleData(limit = 200, offset = this.tableConfig.offset, sortField: any = this.tableConfig.sortField, sortOrder = this.tableConfig.sortOrder, activeStatus = true, search = '') {
    if (this.data?.vehicle) {
      const vehiclePayload = {
        vehicleBaseId: this.data.vehicle.apiResponse?.BaseVehicleID,
        EN: this.data.vehicle.apiResponse?.EngineID,
        CO: this.data.vehicle.apiResponse?.CountryID,
        SM: this.data.vehicle.apiResponse?.SubModelID,
        fetchSizes: 'true',
      };
      if (vehiclePayload.EN && vehiclePayload.CO && vehiclePayload.SM) {
        this.loadingSizes = true;
        this.httpService.getVehicleTireSizes(vehiclePayload).then(
          (vehicleSize: any) => {
            this.vehicleRecommendedSizes = vehicleSize.sizes;
            this.loadingSizes = false;
          },
          (err) => {
            this.loadingSizes = false;
            this.helperService.showToaster('error', err);
          },
        );
      }
    }
  }

  getVehicleTireSizes(query, tireInfo?) {
    if (tireInfo) tireInfo.loadingSizes = true;
    else this.loadingSizes = true;
    this.httpService.getVehicleTireSizeCombinations(query).then(
      (vehicleSize: any) => {
        console.log(vehicleSize);
        if (tireInfo) tireInfo.loadingSizes = false;
        else this.loadingSizes = false;
        if (!query.width) {
          this.allVehicleSizes = vehicleSize.widths;
          this.vehicleSizeSectionName = 'Width';
        } else if (query.width && !query.profile) {
          this.allVehicleSizes = vehicleSize.profiles;
          this.vehicleSizeSectionName = 'Aspect ratio';
        } else if (query.profile) {
          this.allVehicleSizes = vehicleSize.sizes;
          this.vehicleSizeSectionName = 'Rim Diameter';
        }
      },
      (err) => {
        if (tireInfo) tireInfo.loadingSizes = false;
        else this.loadingSizes = false;
        //this.helperService.showToaster('error', err);
      },
    );
  }

  selectTireSize(size: any, recommended = false, tireInfo?, index = null) {
    if (tireInfo) {
      if (recommended) {
        if (size.tireWidth) tireInfo.width = size.tireWidth;
        if (size.tireProfile) tireInfo.ratio = size.tireProfile;
        if (size.tireSize) tireInfo.rim = size.tireSize;
        if (tireInfo.width && tireInfo.ratio && tireInfo.rim) {
          this.getTireConnectBrands(tireInfo, true, null, true, tireInfo);
          this.populateOtherTires(index, 'size');
          this.checkTiresStatus();
        }
      } else {
        if (tireInfo.focus.width) {
          tireInfo.width = size;
          tireInfo.ratio = '';
          tireInfo.rim = '';
          this.getVehicleTireSizes({ width: tireInfo.width });
          tireInfo.focus.ratio = true;
        } else if (tireInfo.focus.ratio) {
          tireInfo.ratio = size;
          tireInfo.rim = true;
          tireInfo.rim = '';
          this.getVehicleTireSizes({ width: tireInfo.width, profile: tireInfo.ratio });
        } else if (tireInfo.focus.rim) {
          tireInfo.rim = size;
          this.populateOtherTires(index, 'size');
          this.checkTiresStatus();
        }

        if (tireInfo.width && tireInfo.ratio && tireInfo.rim) {
          this.getTireConnectBrands(tireInfo, true, null, false, tireInfo);
        }
      }
    } else {
      if (recommended) {
        if (size.tireWidth) this.tireSize.width = size.tireWidth;
        if (size.tireProfile) this.tireSize.ratio = size.tireProfile;
        if (size.tireSize) this.tireSize.rim = size.tireSize;

        if (this.tireSize.width && this.tireSize.ratio && this.tireSize.rim) {
          this.getTireConnectBrands(this.tireSize, true, null, true);
        }
      } else {
        if (this.focus.width) {
          this.tireSize.width = size;
          this.tireSize.ratio = '';
          this.tireSize.rim = '';
          this.getVehicleTireSizes({ width: this.tireSize.width });
          this.focus.ratio = true;
        } else if (this.focus.ratio) {
          this.tireSize.ratio = size;
          this.focus.rim = true;
          this.tireSize.rim = '';
          this.getVehicleTireSizes({ width: this.tireSize.width, profile: this.tireSize.ratio });
        } else if (this.focus.rim) {
          this.tireSize.rim = size;
        }

        if (this.tireSize.width && this.tireSize.ratio && this.tireSize.rim) {
          this.getTireConnectBrands(this.tireSize);
        }
      }
    }
  }

  handleSizeChange(value: any, type: string, tireInfo?: any, index=null) {
    if (tireInfo) {
      tireInfo[type] = value;
      if (type === 'width') {
        if (value?.length === 0) this.getVehicleTireSizes({})
        if (value?.length >= 3) {
          this.getVehicleTireSizes({ width: value });
          this.handleFocus('ratio', tireInfo);
        }
      } else if (type === 'ratio' && tireInfo.width) {
        if (value?.length === 0) this.getVehicleTireSizes({ width: tireInfo.width })
        if (value?.length >= 2) {
          this.getVehicleTireSizes({ width: tireInfo.width, profile: value });
          this.handleFocus('rim', tireInfo);
        }
      }
      if (tireInfo.width && tireInfo.ratio && tireInfo.rim) {
        this.getTireConnectBrands(tireInfo, true, null, false, tireInfo);
        // if(index !== null) this.populateOtherTires(index, 'size');
      }
      this.setDuplicateTire(tireInfo);
      this.checkTiresStatus();
    } else {
      this.tireSize[type] = value;
      if (type === 'width') {
        if (value?.length === 0)this.getVehicleTireSizes({})
        if (value?.length >= 3) {
          this.getVehicleTireSizes({ width: value });
          this.handleFocus('ratio');
        }
      } else if (type === 'ratio' && this.tireSize.width) {
        if (value?.length === 0) this.getVehicleTireSizes({ width: this.tireSize.width })
        if (value?.length >= 2) {
          this.getVehicleTireSizes({ width: this.tireSize.width, profile: value });
          this.handleFocus('rim');
        }
      }
      if (this.tireSize.width && this.tireSize.ratio && this.tireSize.rim) {
        this.getTireConnectBrands(this.tireSize);
      }
    }
  }

  populateOtherTires(index, type) {
    if(this.byPassPopulateOtherTires) {
      return;
    }
    if (index < this.tire.tiresInfo.length) {
      let prevTire;
      this.tire.tiresInfo.forEach((element, tireIndex) => {
        if (index === tireIndex) prevTire = { ...this.tire.tiresInfo[index] };
        if (index < tireIndex) {
          // if (!element.width && !element.ratio && !element.rim && (!element.model || !element.model?.name) && !element.brand?.brandId && !element.brand?._id && !element.rimType) {
            if (!element.width && !element.ratio && !element.rim && prevTire.width && prevTire.ratio && prevTire.rim && type === 'size') {
              element.width = prevTire.width;
              element.ratio = prevTire.ratio;
              element.rim = prevTire.rim;
              element.isSizeDuplicated = true;
            }
            if ((!element.model) && prevTire.model && type === 'model') {
              element.model = prevTire.model;
              element.isModelDuplicated = true;
            }
            if (!element.brand?.brandId && !element.brand?._id && prevTire.brand?._id && type === 'brand') {
              element.brand = prevTire.brand;
              element.isBrandDuplicated = true;
            }
            if (!element.rimType && prevTire.rimType && type === 'rimType') {
              element.rimType = prevTire.rimType;
              element.isRimTypeDuplicated = true;
            }
          // }
        }
      });
    }
  }

  checkForTireConnectConnection() {
    this.httpService
      .isTireConnectConnected({ populateItemAndPricing: true, populateTireConnectRefs: true })
      .then(
        (res: any) => {
          if (res) {
            const { settings, isTireConnectConnected } = res;
            this.isTireConnectConnected = isTireConnectConnected;
            // this.tireConnectSettings = {
            //   tire: {
            //     pricing: settings?.tirePricingId || {},
            //     partsTechCostCalMethod: settings?.tireCostCalMethod || '',
            //   },
            // };

          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {});
  }

  searchLocation(search = '') {
    this.httpService.getTireStorageLocation(search).then(
      (locatons: any[]) => {
        this.locationResults = locatons.map(({ _id, title, totalCapacity, usedCapacity }) => ({ _id, locationId: _id, name: title, totalCapacity, usedCapacity }));
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onStorageLocationUpdate({ name, capacity, color, _id }) {
    this.httpService.updateTireStorageLocation({ title: name, color, capacity, locationId: _id }).then(
      (locaton: any) => {
        if (locaton) {
          if (this.tire && this.tire.storageLocation && this.tire.storageLocation.locationId === locaton._id) {
            this.tire.storageLocation.name = locaton.title;
            this.tire.storageLocation.title = locaton.title;
          }
        }
        this.isCreate(false, '');
        this.newWarehouse = {
          name: '',
          capacity: '',
        };
        this.searchLocation();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onStorageLocationSave(e) {
    if (this.isEditModeCode) {
      this.onStorageLocationUpdate(this.newWarehouse);
      return;
    }
    if (this.newWarehouse.name && this.newWarehouse.capacity) {
      this.httpService.createTireStorageLocation({ title: this.newWarehouse.name, capacity: this.newWarehouse.capacity }).then(
        (data: any) => {
          if (data) {
            this.handleSelect({ locationId: data._id, name: data.title, totalCapacity: data.capacity, usedCapacity: 0 }, 'storageLocation');
            this.locations = [...this.locations, { locationId: data._id, name: data.title, totalCapacity: data.capacity, usedCapacity: 0 }];
            this.locationResults.push({ _id: data._id, locationId: data._id, name: data.title, totalCapacity: data.capacity, usedCapacity: 0 });
            this.locationResults.sort((a, b) => a.name.localeCompare(b.name));
            // this.appUpdateLocations.emit(this.locations);
            this.isCreate(false, '');
            this.newWarehouse = {
              name: '',
              capacity: '',
            };
          }
        },
        (err: any) => {
          if (err === 'Warehouse already exists') {
            if (this.locations && this.locations.length) {
              const location: any = this.locations.find((locItem: any) => locItem.name && toLower(locItem.name) === toLower(e.name));
              if (location && location.locationId) {
                this.handleChange({ locationId: location.locationId, name: location.name }, 'storageLocation');
              }
            }
          }
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  onStorageLocationClear() {
    this.searchLocation('');
  }

  searchBin(search = '', newLocation = false) {
    if (this.tire.storageLocation?.locationId) {
      this.httpService.getBins({ search, locationId: this.tire.storageLocation?.locationId }).then(
        (bins: any[]) => {
          if (newLocation) {
            this.bins = bins.map(({ _id, title, locationId }) => ({ _id, binId: _id, locationId, name: title }));
            if (this.item.tiresInfo[0].storageBin)
              this.tire.storageBin = find(this.bins, {
                locationId: this.item.tiresInfo[0].storageBin && this.item.tiresInfo[0].storageBin.locationId,
                binId: this.item.tiresInfo[0].storageBin && this.item.tiresInfo[0].storageBin.binId,
              });
          }
          this.binResults = bins.map(({ _id, title, locationId }) => ({ _id, binId: _id, locationId, name: title }));
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  onStorageBinUpdate({ name, _id, locationId }) {
    this.httpService.updateBin({ title: name, locationId, binId: _id }).then(
      (bin: any) => {
        if (bin) {
          if (this.tire && this.tire.storageBin && this.tire.storageBin.binId === bin._id) {
            this.tire.storageBin.name = bin.title;
            this.tire.storageBin.title = bin.title;
          }
        }
        this.isCreate(false, '');
        this.newBin = {
          name: '',
        };
        this.searchBin();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onStorageBinSave(e) {
    if (this.isEditModeCode) {
      this.onStorageBinUpdate(this.newBin);
      return;
    }
    if (this.tire.storageLocation?.locationId) {
      this.httpService.createBin({ title: this.newBin.name, locationId: this.tire.storageLocation?.locationId }).then(
        (data: any) => {
          if (data) {
            this.handleSelect({ binId: data._id, locationId: data.warehouseId, name: data.title }, 'storageBin');
            this.locations = [...this.locations, { locationId: data._id, name: data.title }];
            this.binResults.push({ _id: data._id, binId: data._id, locationId: data.warehouseId, name: data.title });
            this.isCreate(false, '');
            this.newBin = {
              name: '',
            };
            // this.appUpdateLocations.emit(this.locations);
          }
        },
        (err: any) => {
          if (err === 'Bin already exists') {
            // if (this.locations && this.locations.length) {
            //   const location: any = this.locations.find((locItem: any) => locItem.name && toLower(locItem.name) === toLower(e.name));
            //   if (location && location.locationId) {
            //     this.handleChange({ locationId: location.locationId, name: location.name }, 'storageLocation');
            //   }
            // }
          }
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  onStorageBinClear() {
    this.searchBin('');
  }

  /** Fetch list of all the tags */
  getTagList() {
    this.httpService.getTags(config.tags.tire).then(
      (categories: any[]) => {
        if (categories && categories.length) {
          this.categories = [...categories];
          this.tagsSuggestion = [...this.categories];
          this.cdr.detectChanges();
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleTagSearch(query: string, tireInfo?: any) {
    if (!query) {
      return;
    }

    if(this.isTireConnectConnected){
      if(tireInfo) tireInfo.tagsSuggestion = tireInfo.allBrands.filter(({ name }) => new RegExp(query, 'i').test(name));
      else this.tagsSuggestion = this.allBrands.filter(({ name }) => new RegExp(query, 'i').test(name));
    }
    else {
      if(tireInfo) tireInfo.tagsSuggestion = tireInfo.allBrands.filter(({ name }) => new RegExp(query, 'i').test(name));
      else this.tagsSuggestion = this.categories.filter(({ name }) => new RegExp(query, 'i').test(name));
    }
    console.log(tireInfo);

    // this.cdr.detectChanges();
  }

  onSearchItem(name: string, query: string) {
    if (name === 'category') {
      this.categoriesSuggestionsResults = this.categoriesSuggestions.filter(({ categoryName }) => categoryName && new RegExp(`${query}`, 'gi').test(categoryName));
    } else if (name === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.subCategoriesSuggestions.filter(({ subCategoryName }) => subCategoryName && new RegExp(`${query}`, 'gi').test(subCategoryName));
    } else if (name === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.subSubCategoriesSuggestions.filter(({ subSubCategoryName }) => subSubCategoryName && new RegExp(`${query}`, 'gi').test(subSubCategoryName));
    }
  }

  handleVendorSearch(query: string) {
    if (!query) {
      return;
    }

    this.vendorsSuggestion = this.suppliers.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  handleClear(type: string, tireInfo?: any) {
    if (type === 'vendor') {
      this.vendorsSuggestion = [...this.suppliers];
    } else if (type === 'category') {
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    } else if (type === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
    } else if (type === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestionsResults);
    } else {
      if(this.isTireConnectConnected) {
        if(tireInfo) tireInfo.tagsSuggestion = [...tireInfo?.tireConnectBrands || [], ...this.categories];
        else this.tagsSuggestion = [...this.tireConnectBrands, ...this.categories];
      }
      else {
        if(tireInfo) tireInfo.tagsSuggestion = [...this.allBrands];
        else this.tagsSuggestion = [...this.categories];
      }
    }
  }

  handleSelect(data: any, type: string, index?, close = null) {
    if (type === 'storageLocation' && data.totalCapacity <= data.usedCapacity) return;
    if (!this.isAllTiresSame && type !== 'storageLocation' && type !== 'storageBin') {
      if (type === 'brand') {
        this.tire.tiresInfo[index].brand = data;
        if (data.isTireConnect) this.getTireConnectBrands(this.tire.tiresInfo[index], false, this.tire.tiresInfo[index], false, this.tire.tiresInfo[index]);
      } else this.tire.tiresInfo[index][type] = data;
      this.setDuplicateTire(this.tire.tiresInfo[index]);
      if(type === 'brand')this.populateOtherTires(index, 'brand');
      this.checkTiresStatus();
    } else {
      if (type === 'brand') {
        this.tire.brand = data;
        if (data.isTireConnect) this.getTireConnectBrands(this.tire, false, this.tireSize);
        this.errors.brand = '';
        this.tire = this.helperService.deepCopy(this.tire);
      } else if (type === 'storageLocation') {
        this.binResults = [];
        this.tire[type] = data;
        this.tire.storageBin = { name: '' };
        this.searchBin('', true);
      } else this.tire[type] = data;
    }
    if (close) close();
  }

  handleChange(value: any, type: string, index = null) {
    // unselect seasonlity
    if (!this.isAllTiresSame && index !== null) {
      this.tire.tiresInfo[index][type] = value;
      this.setDuplicateTire(this.tire.tiresInfo[index]);
      if (type === 'rimType') this.populateOtherTires(index, 'rimType');
      if (type === 'model') {
        // this.tire.tiresInfo[index].focus.model = false;
        this.handleBlur('model', this.tire.tiresInfo[index])
        this.populateOtherTires(index, 'model');
      }
      this.checkTiresStatus();
    } else {
      if (type === 'seasonality') {
        if (value === this.tire.seasonality) {
          value = '';
        }
      }
      if (type === 'stocked') {
        this.tire.sizes[0].stocked = value;
      }

      this.tire[type] = value;
      this.errors[type] = '';
    }
  }

  setDuplicateTire(tire) {
    if (tire.isSizeDuplicated) tire.isSizeDuplicated = false;
    if (tire.isRimTypeDuplicated) tire.isRimTypeDuplicated = false;
    if (tire.isBrandDuplicated) tire.isBrandDuplicated = false;
    if (tire.isModelDuplicated) tire.isModelDuplicated = false;
  }

  handleRimTypeSave({ name }) {
    this.httpService.createTag({ name, type: 'rimType' }).then(
      (tag) => {
        this.rimTypes.push(tag);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleBlur(type: string, tireInfo?, index = null) {
    // if (type === 'model') {
    //   this.tire = this.helperService.deepCopy(this.tire);
    // }
    if (tireInfo) {
      if (type === 'model') {
        setTimeout(() => {
          tireInfo.focus = {[type]: false};
          this.populateOtherTires(index, 'model');
          this.checkTiresStatus();
        }, 500);
      }else{
        if( type=== 'rim')this.handlesizeblur(tireInfo, index)
        setTimeout(() => {
          if(tireInfo.focus) tireInfo.focus[type] = false;
          else tireInfo.focus = {[type]: false};
        }, 500);
      }
    } else {
      // if (type === 'model') {
        setTimeout(() => {
          this.focus[type] = false;
        }, 500);
      // }
      // else{
      //   setTimeout(() => {
      //     this.focus[type] = false;
      //   }, 1000);
      // }
    }
  }

  handlesizeblur(tireInfo?, index = null){
    if(tireInfo.width && tireInfo.ratio && tireInfo.rim && index !== null){
      this.populateOtherTires(index, 'size');
    }
  }

  handleFocus(type: string, tireInfo?) {
    if (tireInfo) {
      if(tireInfo.focus) tireInfo.focus[type] = true;
      else tireInfo.focus = {[type]: true};
    } else {
      this.errors[type] = '';
      this.focus[type] = true;
    }
  }

  handleAddSize() {
    this.tire.sizes.push(this.helperService.deepCopy(this.defaultSizeObject));
  }

  handleAddTireInfo(data?: any) {
    if (this.isEnhancedTSEnabled && data) {
      const dataObj: any = this.helperService.deepCopy(data);
      dataObj.activeIndex = 0;
      dataObj.isManuallyAdded = true;
      this.tire.tiresInfo.push(this.helperService.deepCopy(dataObj));
    } else {
      this.tire.tiresInfo.push(this.helperService.deepCopy(this.defaultTireInfo));
    }
    this.disabledDuplicate = this.tire.tiresInfo.length >= 6;
  }

  handleDeleteTireSize(index: number) {
    this.tire.sizes.splice(Number(index), 1);
    this.tire.errors[index] = {};
  }

  handleDeleteStorageTire(index: number) {
    this.tire.tiresInfo.splice(Number(index), 1);
    this.disabledDuplicate = this.tire.tiresInfo.length >= 6;
    // this.tire.errors[index] = {};
  }

  handleCloseModal() {
    this.dynamicDialogRef.close();
  }

  handleTirestoragePrint() {
    let hasUnsavedChanges: boolean = false;
    // if(this.isDeepCopy) {
    //   //this.defaultTireData = this.helperService.deepCopy(this.tire.tiresInfo)
    //   this.isDeepCopy = false
    // }

    if (this.tire.tiresInfo && this.defaultTireData.tiresInfo && this.tire.tiresInfo.length === this.defaultTireData.tiresInfo.length) {
      for (let i = 0; i < this.tire.tiresInfo.length; i++) {
        const defaultInfo = this.defaultTireData.tiresInfo[i];
        const tireDataInfo = this.tire.tiresInfo[i];
        if(tireDataInfo?.brand) {
          tireDataInfo.brand._id = tireDataInfo?.brand?._id || tireDataInfo?.brand?.brandId;
        }
        if(defaultInfo?.brand) {
          defaultInfo.brand._id = defaultInfo?.brand?._id || defaultInfo?.brand?.brandId;
        }

        if (
          defaultInfo?.brand?._id !== tireDataInfo?.brand?._id ||
          defaultInfo.model !== tireDataInfo.model ||
          defaultInfo.size !== tireDataInfo.size ||
          defaultInfo?.seasonality?.value !== tireDataInfo?.seasonality?.value ||
          defaultInfo.partNumber !== tireDataInfo.partNumber ||
          defaultInfo?.tirePosition?.value !== tireDataInfo?.tirePosition?.value ||
          defaultInfo.treadDepth !== tireDataInfo.treadDepth ||
          defaultInfo?.storageLocation?.locationId !== tireDataInfo?.storageLocation?.locationId ||
          defaultInfo?.rimType?.name !== tireDataInfo?.rimType?.name ||
          defaultInfo.tireLabel !== tireDataInfo.tireLabel ||
          defaultInfo.recommendReplacement !== tireDataInfo.recommendReplacement
        ) {
          hasUnsavedChanges = true;
          break;
        }
      }
    }
    //const hasUnsavedChanges = isEqual(this.tire.tiresInfo,this.defaultTireData.tiresInfo);

    if (hasUnsavedChanges) {
      this.handleSubmit(hasUnsavedChanges);

    } else {
      this.printTireLabel();
    }
  }

  printTireLabel() {
    if (this.isPrintingLabel) {
      return;
    }
    this.isPrintingLabel = true;
    this.httpService
      .downloadTireStoragePdf({ orderId: this.item.storageRO && this.item.storageRO.orderId, tireStorageId: this.tireId })
      .then(
        (url) => {
          window.open(url, '_blank');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isPrintingLabel = false;
      });
  }

  handleValidation() {
    let isValid = true;

    if (!this.tire.brand) {
      this.errors.brand = 'Brand required';
      isValid = false;
    }

    if (!this.tire.model) {
      this.errors.model = 'Vendor required';
      isValid = false;
    }

    if (this.isEnhancedTSEnabled) {
      isValid = true;

      if (!trim(this.tire.title)) {
        this.errors.title = 'Title required';
        this.tire.title = '';
        isValid = false;
      }

      if (this.tire.tiresInfo && this.tire.tiresInfo.length) {
        this.tire.tiresInfo.forEach((tire: any) => {
          tire.activeIndex = null;
          this.cdr.detectChanges();

          if (!trim(tire.brand)) {
            if (!tire.errors) {
              tire.errors = {};
            }

            tire.errors.brand = 'Brand required';
            tire.brand = '';
            isValid = false;
          }

          if (!trim(tire.model)) {
            if (!tire.errors) {
              tire.errors = {};
            }

            tire.errors.model = 'Vendor required';
            tire.model = '';
            isValid = false;
          }

          if (!trim(tire.size)) {
            if (!tire.errors) {
              tire.errors = {};
            }

            tire.errors.size = 'Size required';
            tire.size = '';
            isValid = false;
          }

          // if (!tire?.tirePosition) {
          //   if (!tire.errors) {
          //     tire.errors = {};
          //   }

          //   tire.errors.tirePosition = 'Tire position required';
          //   isValid = false;
          // }

          // if (!tire?.oldTreadDepth && tire?.treadDepth && (tire?.treadDepth < 1 || tire?.treadDepth > 32)) {
          //   if (!tire.errors) {
          //     tire.errors = {};
          //   }
          //   tire.errors.treadDepth = 'Must be between 1 to 32';
          //   isValid = false;
          // }

          if (!tire?.oldTreadDepth && tire?.treadDepth !== undefined) {
            if (tire.treadDepth >= 1 && tire.treadDepth <= 32) {
              if (!tire.errors) {
                tire.errors = {};
              }
              tire.errors.treadDepth = 'Must be between 1 to 32';
              isValid = false;
            }
          }

          if (!isValid) {
            tire.activeIndex = 0;
          }
        });

        // Always should be at the very end of this code
        if (this.tire.tiresInfo.length > 6) {
          isValid = false;
          this.helperService.showToaster('error', 'Tire storage information cannot be greater than 6 tires.');
        }
      } else {
        isValid = false;
        this.helperService.showToaster('error', 'Please add tire in tire storage information');
      }
    } else {
      this.tire.sizes.forEach(({ size, title }: any, index: number) => {
        if (this.tire.errors[index] && this.tire.errors[index].title) {
          this.tire.errors[index] = {
            title: this.tire.errors[index].title,
          };
        } else {
          this.tire.errors[index] = {};
        }

        if (!size) {
          this.tire.errors[index].size = 'Size required';
          isValid = false;
        }
        if (!title) {
          this.tire.errors[index].title = 'Title required';
          isValid = false;
        }
      });
    }
    return isValid;
  }

  /** Set Item Ref */
  setItemRef() {
    if (this.tire && this.tire.qboId && this.qboItemRefs.length) {
      if (this.tire.sizes[0]) {
        this.tire.sizes[0].qboItemRef = find(this.qboItemRefs, {
          qboId: this.tire.qboId,
        });
      }
    }
  }

  getUpdatedTireInfoLogs() {
    this.tire.tiresInfo.forEach((tire: any, index: number) => {
      if (this.item && this.item.storageRO) {
        tire.orderId = this.item.storageRO && this.item.storageRO.orderId;
        tire.code = this.item.storageRO && this.item.storageRO.code;
      }
      tire.tireState = `Tire ${index + 1}`;
      tire.openFrom = this.openFrom;
      if (tire.storageLocation) {
        if (tire.storageLocation.name !== tire.previousStorageLocation) {
          tire.isUpdated = true;
          tire.storageLocation.previousName = tire.previousStorageLocation;
        }
      }
    });
  }

  validateForm(): boolean {
    let isValid: boolean = true;
    if(this.isAllTiresSame) {
      if(!trim(this.tireSize.width)) {
        isValid = false;
      }
      if(!trim(this.tireSize.ratio)) {
        isValid = false;
      }
      if(!trim(this.tireSize.rim)) {
        isValid = false;
      }

      if(!this.tire?.brand?.name) {
        isValid = false;
      }
      if(!this.tire?.model) {
        isValid = false;
      }

      if(!this.tire?.rimType?.name) {
        isValid = false;
      }
    } else {

      if(!this.tire.tiresInfo?.every((tireInfo: any) => trim(tireInfo?.width))) {
        isValid = false;
      }
      if(!this.tire.tiresInfo?.every((tireInfo: any) => trim(tireInfo?.ratio))) {
        isValid = false;
      }
      if(!this.tire.tiresInfo?.every((tireInfo: any) => trim(tireInfo?.rim))) {
        isValid = false;
      }

      if(!this.tire.tiresInfo?.every((tireInfo: any) => tireInfo?.brand?.name)) {
        isValid = false;
      }
      if(!this.tire.tiresInfo?.every((tireInfo: any) => tireInfo?.model)) {
        isValid = false;
      }

      if(!this.tire.tiresInfo?.every((tireInfo: any) => tireInfo?.rimType?.name)) {
        isValid = false;
      }
    }

    if(!this.isInspectionCompleted()) {
      isValid = false;
    }

    return isValid;
  }

  validateMarkStoredCriteria(): boolean {
    let isValid: boolean = true;
    if(!this.tire?.storageLocation || !this.tire?.storageLocation?.locationId) {
      isValid = false;
    }

    return isValid;
  }

    handleSubmit(isFromLabel?: boolean) {
    // if (!this.handleValidation() || this.isProcessing) {
    //   return;
    // }
    // this.getUpdatedTireInfoLogs();
    let isValidate = true;
    // if (this.tire.tiresInfo.length && !this.isAllTiresSame && !this.isOpenFromInventory) {
    //   this.tire.tiresInfo.forEach((element) => {
    //     if (!element.isCompleted) {
    //       isValidate = false;
    //       return;
    //     }
    //   });
    // }
    if (!isValidate) return;
    let tire: any;
    if (this.isOpenFromInventory) {
      tire = this.item;
    } else {
      tire = {
        cost: Number(this.serviceItem.cost),
        price: Number(this.serviceItem.price),
        code: this.data.order?.code || '',
        title: this.serviceItem.title,
        model: this.isTireConnectConnected && this.tire.model?.name ? this.tire.model?.name : this.tire.model,
        size: this.tire.size || '',
        type: 'tireStorage',
        count: 0,
        // description: this.serviceItem.description,
        // descriptionFR: this.serviceItem.descriptionFR,
        notes: this.serviceItem.description,
        isTaxable: this.serviceItem.isTaxable,
        status: this.serviceItem.status,
        seasonality: this.tire.seasonality,
        displayDescOnOrder: this.serviceItem.displayDescOnOrder,
        displayHoursOnOrder: this.serviceItem.displayHoursOnOrder,
        commissionable: this.serviceItem.commissionable,
        tireStorageStatus: '',

      };

      if(this.validateForm()) {
        tire.tireStorageStatus = 'remove';
        if(this.validateMarkStoredCriteria()) {
          tire.tireStorageStatus = 'store';
        }
      }


    }
    if (this.tire.tiresInfo && this.tire.tiresInfo.length) {
      tire.count = this.tire.tiresInfo.length;
      if (this.isAllTiresSame) {
        this.setTireInfo();
        tire.tiresInfo = this.tire.tiresInfo;
      } else {
        const tiresInfo = this.helperService.deepCopy(this.tire.tiresInfo);
        tiresInfo.forEach((element) => {
          element.brand = { brandId: element.brand?._id || element.brand?.brandId, name: element.brand?.name };
          element.rimType = element.rimType && element.rimType.name;
          element.model = element.model?.name ? element.model.name : element.model;
          element.size = `${element.width || ''}/${element.ratio || ''}/${element.rim || ''}`;
          element.seasonality = this.tire.seasonality;
          element.storageLocation = this.tire.storageLocation || null;
          element.storageBin = this.tire.storageBin || null;
          delete element.tagsSuggestion;
          delete element.tireConnectBrands;
          delete element.allBrands;
        });

        tire.tiresInfo = tiresInfo;
      }
    }

    if (this.isNewCategoriesEnabled && this.isSalesCodeEnabled) {
      if (this.tire.salesCode && this.tire.salesCode?.salesCodeId) tire.salesCode = this.tire.salesCode;
      else tire.salesCode = {};
    }

    if (this.data.customer) {
      tire.customer = this.data.customer;
    }

    if (this.data.vehicle) {
      tire.vehicle = this.data.vehicle;
    }

    if (!this.tireId) {
      if (this.data.order) {
        tire.storageRO = this.data.order;
      }
    }

    // if (size.qboItemRef && size.qboItemRef.qboId) {
    //   tire.qboItemRefId = size.qboItemRef.qboId;
    //   tire.qboId = size.qboItemRef.qboId;
    // }

    if (this.tire.brand) {
      tire.brand = this.tire.brand.name;
      tire.category = {
        categoryId: this.tire.brand._id,
        name: this.tire.brand.name,
      };
    }

    if (this.tire.internalNotes) {
      tire.notes = this.tire.internalNotes;
      // tire.description = this.tire.internalNotes;
    }

    if (this.tire.vendor) {
      tire.supplier = {
        supplierId: this.tire.vendor._id,
        name: this.tire.vendor.name,
      };
    }

    if (this.isNewItemCategoriesEnable && this.isSalesCodeEnabled) {
      tire.isAutoAssign = this.isAutoAssign;
    }

    if (this.tireId) {
      this.handleUpdateTire(tire, isFromLabel);
    } else {
      this.handleCreateTire(tire, isFromLabel);
    }
  }

  handleUpdateTire(tire: any, isFromLabel?: boolean) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    delete tire.storageRO;
    const item = this.helperService.deepCopy(tire);
    if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
      tire.salesCode = this.defaultSalesCode;
    }

    if(this.item.associatedInspection && this.service?.inspection) {
      tire.orderInspectionId = this.service?.inspection?.inspectionId?._id;
    }

    this.httpService.updateItem({ ...tire, _id: this.tireId }).then(
      (res: any) => {
        delete tire.tireStorageStatus;
        this.handleCloseModal();
        this.dataService.sendData(this.dataService.typePassData('info-updated', {}));
        this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
        this.helperService.showToaster('success', 'Tire storage updated');
        this.isProcessing = false;

        if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
          res.salesCode = item?.salesCode;
        }

        // if (this.isSalesCodeEnabled) {
        //   this.logPXGaingSightCustomEvent(res);
        // }

        if(this.item.associatedInspection) {
          this.updateAssociatedInspection(res);
        }

        if (this.orderServiceId) {
          this.dataService.sendData(
            this.dataService.typePassData('ro-service-item', {
              ...res,
              actionType: 'update',
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
            }),
          );
        }
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      },
    ).finally(() => {
      if(isFromLabel) {
        this.printTireLabel();
      }
    });
  }

  async updateAssociatedInspection(data: any) {
    try {
      let inspectionId = this.item.orderInspectionId;
      if(!inspectionId && this.service?.inspection && this.service?.inspection?.inspectionId) {
        inspectionId = this.service?.inspection?.inspectionId?._id;
      }
      const obj = {
        tiresInfo: data.tiresInfo,
        isEditBlank: !(!!data?.tiresInfo?.length),
        tireCount: data?.tiresInfo?.length
      };
      if(inspectionId) await this.httpService.updateStorageInspection(obj, inspectionId);
    } catch(err) {
      this.helperService.showToaster('error', err);
    }
  }

  logPXGaingSightCustomEvent(res: any) {
    if (res?.salesCode?.salesCodeId && res?.salesCode?.salesCodeId !== this.defaultSalesCode?.salesCodeId) {
      const logInfo = {
        itemName: res?.title || res?.name,
        salesCodeName: res?.salesCode?.title,
        salesCode: res?.salesCode?.shortName,
        category: res?.category?.name,
        subCategory: res?.category?.subCategoryName,
        itemType: res?.type,
        assignmentType: this.isAutoAssign ? 'Auto' : 'User has assigned sales code directly from the Catalog/RO',
      };
      this.helperService.logPXGaingSightEvent('Sales code assigned to an item', logInfo);
    }
  }

  handleCreateTire(tire: any, isFromLabel?: boolean) {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;
    const item = this.helperService.deepCopy(tire);
    if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
      tire.salesCode = this.defaultSalesCode;
    }
    this.httpService.createTireStorage(tire).then(
      (tire) => {
        this.handleCloseModal();
        this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
        this.helperService.showToaster('success', 'Tire created');

        if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
          tire.salesCode = item?.salesCode;
        }

        if (this.isSalesCodeEnabled) {
          this.logPXGaingSightCustomEvent(tire);
        }

        if (this.orderServiceId) {
          this.dataService.sendData(
            this.dataService.typePassData('ro-service-item', {
              ...tire,
              actionType: 'create',
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
            }),
          );
        }

        this.isProcessing = false;
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      },
    ).finally(() => {
      if(isFromLabel) {
        this.printTireLabel();
      }
    });
  }

  onUpdateSupplier(data) {
    this.httpService.updateSupplier(data).then(
      (res: any) => {
        for (let i = 0; i < this.suppliers.length; i++) {
          if (this.suppliers[i]._id === res._id) {
            this.suppliers[i].name = data.name;
            break;
          }
        }

        for (let i = 0; i < this.vendorsSuggestion.length; i++) {
          if (this.vendorsSuggestion[i]._id === res._id) {
            this.vendorsSuggestion[i].name = data.name;
            break;
          }
        }

        if (this.tire.vendor && this.tire.vendor._id === res._id) {
          this.tire.vendor.name = data.name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        const tempCategories: any[] = this.helperService.deepCopy(this.categories);
        this.categories = [];
        for (let i = 0; i < tempCategories.length; i++) {
          if (tempCategories[i]._id === _id) {
            tempCategories[i].name = name;
            break;
          }
        }
        this.categories = tempCategories;
        this.allBrands = [...this.categories];
        for (let i = 0; i < this.tagsSuggestion.length; i++) {
          if (this.tagsSuggestion[i]._id === _id) {
            this.tagsSuggestion[i].name = name;
            break;
          }
        }

        if (this.tire.brand && this.tire.brand._id === _id) {
          this.tire.brand.name = name;
        }
        this.cdr.detectChanges();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleCreateBrand(data: any) {
    data.type = config.tags.tire;

    if (!data.isForFurtureUse) {
      this.categories.push(data);
      this.tagsSuggestion.push(data);
    } else {
      this.httpService.createTag(data).then(
        (category: any) => {
          if (category) {
            const tempCategories: any[] = this.helperService.deepCopy(this.categories);
            this.categories = [];
            tempCategories.push(category);
            this.helperService.showToaster('success', 'Brand created');
            this.categories = tempCategories;
            this.tagsSuggestion.push(category);
            this.allBrands = [...this.categories]
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  handleCreateSupplier(data: any) {
    if (!data.isForFurtureUse) {
      this.suppliers.push(data);
      this.vendorsSuggestion.push(data);
    } else {
      this.httpService.createSupplier(data).then(
        (supplier: any) => {
          if (supplier) {
            this.helperService.showToaster('success', 'Vendor created');
            this.suppliers.push(supplier);
            this.vendorsSuggestion.push(supplier);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err.messages);
        },
      );
    }
  }

  updateLocations(locations: any[]) {
    this.locations = [...locations];
  }

  onSelectTire(isChecked: boolean) {
    this.isAllTiresSame = !isChecked;
    if (!this.isAllTiresSame) {
      if (this.tire.tiresInfo?.length) this.setTireInfo(true);
    } else {
      this.tire.brand = this.tire.tiresInfo[0]?.brand;
      this.tire.model = this.tire.tiresInfo[0]?.model || '';
      this.tire.rimType = this.tire.tiresInfo[0]?.rimType;
      this.tireSize.width = this.tire.tiresInfo[0]?.width || '';
      this.tireSize.ratio = this.tire.tiresInfo[0]?.ratio || '';
      this.tireSize.rim = this.tire.tiresInfo[0]?.rim || '';
      this.tagsSuggestion = [...this.tireConnectBrands, ...this.categories];
    }
  }

  setTireInfo(updateSeason = false) {
    this.tire.tiresInfo.forEach((element) => {
      element.brand = { brandId: this.tire?.brand?._id || this.tire?.brand?.brandId, name: this.tire?.brand?.name };
      element.rimType = updateSeason ? this.tire.rimType : this.tire.rimType && this.tire.rimType.name;
      element.model = this.tire.model;
      element.width = this.tireSize.width;
      element.ratio = this.tireSize.ratio;
      element.rim = this.tireSize.rim;
      element.size = `${this.tireSize.width || ''}/${this.tireSize.ratio || ''}/${this.tireSize.rim || ''}`;
      element.seasonality = this.tire.seasonality;
      element.storageLocation = this.tire.storageLocation || null;
      element.storageBin = this.tire.storageBin || null;
      if(!updateSeason){
        delete element.tagsSuggestion;
        delete element.tireConnectBrands;
        delete element.allBrands;
      }else{
        if(this.tagsSuggestion?.length) element.tagsSuggestion = [...this.tireConnectBrands, ...this.categories];
        if(this.allBrands?.length) element.allBrands = this.allBrands;
        if(this.tireConnectBrands?.length) element.tireConnectBrands = this.tireConnectBrands;
      }
    });
    this.checkTiresStatus();
  }

  onFocus(type) {
    this.errors[type] = '';
  }
  handleChangeWarehouse(type, data) {
    this.newWarehouse[type] = data;
  }
  handleChangeBin(type, data) {
    this.newBin[type] = data;
  }

  onEditItem(item, type) {
    this.toggleCustomStyles(false);
    this.isCreateNew = true;
    this.isEditModeCode = true;
    if (type === 'warehouse') {
      item.capacity = item.totalCapacity;
      this.newWarehouse = {
        ...item,
      };
    } else if (type === 'bin') {
      item._id = item.binId;
      this.newBin = {
        ...item,
      };
    }
  }

  isCreate(data, type) {
    this.toggleCustomStyles(!data);
    if (data === true) {
      if (type === 'warehouse') {
        Object.keys(this.newWarehouse).forEach((key) => {
          this.newWarehouse[key] = '';
          this.onFocus(key);
        });
      } else if (type === 'bin') {
        Object.keys(this.newBin).forEach((key) => {
          this.newBin[key] = '';
          this.onFocus(key);
        });
      }
    }
    this.isEditModeCode = false;
    this.isCreateNew = data;
  }

  toggleCustomStyles(shouldAdd: boolean) {
    const targetElement = this.el.nativeElement.querySelector('.autocomplete .autocomplete-wrapper .autocomplete-list-wrapper .custom-create-field');

    if (targetElement) {
      if (shouldAdd) {
        this.renderer.addClass(targetElement, 'custom-style-class');
      } else {
        this.renderer.removeClass(targetElement, 'custom-style-class');
      }
    }
  }

  handleOpenInspectionDialog() {
    if(!this.item?.associatedInspection) {
      return;
    }
    if(this.openFrom === 'RO' && this.service?.inspection) {
      const inspectionData = {
        inspectionId: this.service?.inspection?.inspectionId?._id,
        serviceId: this.service._id,
        isAlCertified: this.service?.inspection?.inspectionId?.isAlCertified,
      };
      this.dataService.sendData(this.dataService.typePassData('open-inspection-modal', inspectionData));
    } else if(this.openFrom && this.openFrom !== 'RO') {
      let ref;
      if (this.dataService.isDvi2Enabled) {
        ref = this.dialogService.open(VehicleInspectionModalComponent, {
          width: '850px',
          styleClass: 'small-heading-dialog vehicle-medium',
          showHeader: false,
          data: {
            inspectionId: this.item.orderInspectionId,
            estimateId: this.item.storageRO?.orderId,
            customer: this.item?.customer,
            service: {},
            isReadonly: true,
            isFinalized: false,
            currentLang: this.currentLang,
          },
        });
      }
    }
  }

  getLastTireStorageData(vehicleId: string) {
    const data = {
      offset: 0,
      limit: 1,
      sortField: 'dateOfRemoval',
      sortOrder: -1,
      storageStatus: 'return',
      type: 'tireStorage',
      page: 0,
      sort: 'dateOfRemoval',
      order: -1,
      vehicleId
    }
    this.httpService.getTireStorage(data).then(
      ({ records }: any) => {
        if (records && records?.length) {
          this.lastTireStorage = records[0];
          if(this.lastTireStorage?.tiresInfo?.length) {
            this.lastTireStorage?.tiresInfo?.forEach((tireInfo: any) => {
              if(!tireInfo?.model) {
                tireInfo.model = this.lastTireStorage.model;
              }
              if(!tireInfo.size) {
                tireInfo.size = this.lastTireStorage.size;
              }
              if(!tireInfo.brand) {
                if (this.lastTireStorage.category && this.lastTireStorage.category.categoryId) {
                  tireInfo.brand = {
                    _id: this.lastTireStorage.category.categoryId,
                    name: this.lastTireStorage.category.name,
                  };
                } else if(this.lastTireStorage.brand) {
                  tireInfo.brand = {
                    name: this.lastTireStorage.brand,
                  };
                }
              }
              this.makeTireDataBackwardCompatible(tireInfo);
            });
          }

          const groupedData = this.getUsePastGroupedData(this.lastTireStorage?.tiresInfo || []);
          if(groupedData) {
            const tireDetails: any[] = Object.values(groupedData);
            if(tireDetails?.length > 1) {
              this.isUsedPastStorageAllSame = false;
            } else if(tireDetails?.length === 1) {
              this.isUsedPastStorageAllSame = true;
            }
            this.createUsepastStorageTooltip(tireDetails || []);
          }

        }
      },
      (error) => {
        this.helperService.showToaster('error', error);
      }
    );
  }

  getUsePastGroupedData(tiresInfo: any[]): any {
    let groupedInfo: any = {};
    if(tiresInfo?.length) {
      tiresInfo?.forEach((info: any) => {
        const brand = info?.brand && info.brand?.name;
        const model = info.model;
        const size = info?.size;
        const rimType = info?.rimType;
        let key = `${brand || ''} ${model || ''} ${size || ''} ${rimType ? ' | '+rimType : ''}`;
        if(!groupedInfo[key]) {
          groupedInfo[key] = {};
        }

        groupedInfo[key] = {
          brand,
          model,
          size,
          rimType,
          tooltipText: key
        };
      });
    }
    if(Object.keys(groupedInfo || {})?.length) {
      return groupedInfo;
    } else {
      return null;
    }

  }

  createUsepastStorageTooltip(tiresDetails: any[]) {
    if(tiresDetails?.length) {
      let tooltip = `<div class="flex-column">`;
      tiresDetails.forEach((item: any) => {
        tooltip +=`<span>${item.tooltipText}</span>`
      });
      tooltip +=`</div>`;
      this.usePastStorageTooltip = tooltip;
      this.usePastStorageBtnText = `${tiresDetails[0].brand || ''} ${tiresDetails[0].model || ''} ${tiresDetails[0].size || ''}`;
    }
  }

  populateLastTireStorageData() {
    if(this.lastTireStorage?._id && this.lastTireStorage?.tiresInfo && this.lastTireStorage?.tiresInfo?.length) {
      if(this.tire?.tiresInfo && this.tire.tiresInfo?.length) {
        if(!this.isUsedPastStorageAllSame) {
          this.onSelectTire(true);
        }

        this.byPassPopulateOtherTires = true;
        this.tire.tiresInfo?.forEach((tireInfo: any, index: number) => {
          const obj = find(this.lastTireStorage?.tiresInfo, (item: any) => { return (toLower(item.tireLabel) === toLower(tireInfo.tireLabel) || tireInfo.tireLabel.includes(item.tirePosition))});

          if(obj) {
            if(obj.brand && obj.brand.brandId) {
              const brand = find(tireInfo.tagsSuggestion || this.tagsSuggestion, {name: obj.brand.name});
              if(brand) {
                if(!this.isUsedPastStorageAllSame) {
                  this.handleSelect(brand, 'brand', index);
                } else {
                  this.handleSelect(brand, 'brand');
                }

              }
            }

            if(obj.rimType) {
              if(!this.isUsedPastStorageAllSame) {
                this.handleChange({name: obj.rimType}, 'rimType', index);
              } else {
                this.handleChange({name: obj.rimType}, 'rimType');
              }

            }

            if(this.lastTireStorage.seasonality) {
              this.handleChange(this.lastTireStorage.seasonality, 'seasonality');
            }

            if(obj.size) {
              const tireSize = this.helperService.tireSizeParser(obj.size);
              if(Object.keys(tireSize || {})?.length) {
                if(!this.isUsedPastStorageAllSame) {
                  this.handleSizeChange(tireSize?.tireWidth, 'width', tireInfo, index);
                } else {
                  this.handleSizeChange(tireSize?.tireWidth, 'width');
                }

                //if(tireSize?.length > 1) {
                  if(!this.isUsedPastStorageAllSame) {
                    this.handleSizeChange(tireSize?.tireProfile, 'ratio', tireInfo, index);
                  } else {
                    this.handleSizeChange(tireSize?.tireProfile, 'ratio');
                  }

                //}
                //if(tireSize?.length > 2) {
                  if(!this.isUsedPastStorageAllSame) {
                    this.handleSizeChange(tireSize?.tireSize, 'rim', tireInfo, index);
                  } else {
                    this.handleSizeChange(tireSize?.tireSize, 'rim');
                  }

                //}

                if(!tireInfo?.focus) {
                  tireInfo.focus = {};
                }

                if(!tireInfo?.focus) {
                  tireInfo.focus = {};
                }

                tireInfo.focus.width = false;
                tireInfo.focus.ratio = false;
                tireInfo.focus.rim = false;
                this.focus.width = false;
                this.focus.ratio = false;
                this.focus.rim = false;
              }
            }

            if(obj.model) {
              this.handleChange(obj.model, 'model', index);
            }

          }
        });
      }
    }
    this.byPassPopulateOtherTires = false;
  }
}
